// src/App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { AppKitProvider } from "./wagmi.config";
import { ThemeProvider, CssBaseline, createTheme } from "@mui/material";

import VerifyEmail from "./components/VerifyEmail";
import { attachAuthAutoRefresh } from "./components/firebase";

import FinishEmailLogin from "./pages/FinishEmailLogin";
import FinishEmailAttach from "./pages/FinishEmailAttach";

import RwaApp from "./appRWAPromo/RwaApp";

// Referral capture (query ?ref=...)
import { storeRefFromUrl } from "./lib/referral";

const theme = createTheme({
  palette: {
    mode: "light",
    background: {
      default: "#f5f7fa",
      paper: "#ffffff",
    },
    text: {
      primary: "#0f172a",
      secondary: "#6b7280",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: { height: "100%" },
        body: { minHeight: "100%" },
        "#root": { minHeight: "100%", isolation: "isolate" },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: "none" },
      },
    },
  },
});

function ReferralCapture() {
  const location = useLocation();

  useEffect(() => {
    // Capture ?ref=... on every navigation that changes query string
    storeRefFromUrl();
  }, [location.search]);

  return null;
}

function AppRoutes() {
  const location = useLocation();
  const state =
    location.state && location.state.background
      ? { background: location.state.background }
      : null;

  return (
    <>
      {/* Global referral catcher */}
      <ReferralCapture />

      {/* Main layer */}
      <Routes location={state?.background || location}>
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/finish-email-login" element={<FinishEmailLogin />} />
        <Route path="/finish-email-attach" element={<FinishEmailAttach />} />
        <Route path="/*" element={<RwaApp />} />
      </Routes>
    </>
  );
}

export default function App() {
  useEffect(() => {
    const detach = attachAuthAutoRefresh();
    return detach;
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      <AppKitProvider>
        <Router>
          <AppRoutes />
        </Router>
      </AppKitProvider>
    </ThemeProvider>
  );
}
